<template>
    <div class="container box-like">
        <div class="page-content">
            <img src="@/assets/404.png" />
            <div class="info">
                <p>抱歉！</p>
                <p>当前页面不存在...</p>
                <p>请检查您输入的网站是否正确，或点击下面的按钮返回首页</p>
                <a-button type="primary" @click="$router.push('/index')">返回首页</a-button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    components: {},
    created() {},
    props: {},
    watch: {},
    methods: {}
}
</script>

<style scoped lang="less">
    .container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;

        .page-content {
            img {
                width: 500px;
                height: 350px;
            }

            .info {
                line-height: 20px;

                p:nth-child(1) {
                    font-weight: bold;
                    font-size: 35px;
                    color: #2F9BFF;
                }

                p:nth-child(2) {
                    font-size: 20px;
                }
            }
        }

    }
</style>
